<template>
  <div class="view_page">
    <div
      class="xd_box view_page_form"
      :class="{ 'm-bottom-lg': !isShowBtn }"
      v-if="formColumns.length"
    >
      <!-- 查询UI -->
      <BaseForm
        label-position="left"
        :span="6"
        :labelWidth="80"
        :form-data="formData"
        :columns="formColumns"
        v-bind="formProps"
      >
        <template slot="search" slot-scope="{ row, column, index }">
          <slot name="search" :row="row" :column="column" :index="index" />
        </template>

        <!-- Form 表单 插槽 -->
        <template
          v-for="item in todoFormSlot"
          :slot="item.slot"
          slot-scope="{ row, column, index }"
        >
          <slot :name="item.slot" :row="row" :column="column" :index="index" />
        </template>
      </BaseForm>
    </div>
    <!-- 操作按钮 -->
    <div
      class="view_page_btn clearfix"
      :style="{ padding: caclPadding }"
      v-if="isShowBtn"
    >
      <div class="left">
        <slot name="leftBtn" />
      </div>
      <div class="right">
        <slot name="rightBtn" />
      </div>
    </div>

    <!-- 表格UI -->
    <div v-if="isShowTable">
      <Table
        @on-selection-change="handleSelectionChange"
        border
        ref="tableRef"
        v-bind="tableProps"
      >
        <!-- Table 插槽 -->
        <template
          v-for="item in calcSlot"
          :slot="item.slot"
          slot-scope="{ row, column, index }"
        >
          <slot :name="item.slot" :row="row" :column="column" :index="index" />
        </template>
      </Table>
    </div>
    <!-- 自定义内容 -->
    <div class="clearfix" v-else>
      <template>
        <slot name="listTodo" v-for="item in tableProps.data" :data="item" />
        <div
          class="no_data_wapper"
          v-if="tableProps.data && !tableProps.data.length"
        >
          暂无数据
        </div>
      </template>
    </div>

    <div class="base_page" v-if="Object.keys(pageProps || {}).length">
      <Page
        v-bind="calcPage"
        @on-change="handlePageIndexChange"
        @on-page-size-change="handlePageSizeChange"
      />
    </div>
  </div>
</template>

<script>
const defaultPageProps = {
  showElevator: true,
  showSizer: true,
  showTotal: true,
};

export default {
  name: "ViewPage",
  props: {
    formProps: {
      type: Object,
      default() {
        return {};
      },
    },
    formData: {
      type: Object,
      default() {
        return {};
      },
    },
    formColumns: {
      type: Array,
      default() {
        return [];
      },
    },
    tableProps: {
      type: Object,
      default() {
        return {};
      },
    },
    pageProps: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    isShowBtn() {
      if (this.$slots.leftBtn || this.$slots.rightBtn) return true;
      return false;
    },
    caclPadding() {
      if (!this.formColumns.length) return "0px 32px 15px 32px";
      return "15px 32px";
    },
    calcPage() {
      return { ...defaultPageProps, ...this.pageProps };
    },
    calcSlot() {
      const columns = this.tableProps.columns || [];
      return columns.filter((item) => item.slot);
    },
    todoFormSlot() {
      return this.formColumns.filter((item) => item.slot);
    },
    isShowTable() {
      if (!this.tableProps.columns) return false;
      if (this.tableProps.columns && !this.tableProps.columns.length) {
        return false;
      }
      return true;
    },
  },
  methods: {
    handleSelectionChange(selection) {
      this.$emit("handleSelectChange", selection);
    },
    handlePageIndexChange(pageIndex) {
      this.$emit("handlePageChange", { pageIndex });
    },
    handlePageSizeChange(pageSize) {
      this.$emit("handlePageChange", { pageSize });
    },
  },
};
</script>

<style lang="less" scoped>
.view_page {
  .xd_box {
    padding: 15px 32px 0px 32px;
  }
 ::v-deep .ivu-table-wrapper {
    margin-bottom: 10px;
  }
 ::v-deep .view_page_form {
    .ivu-form-item {
      margin-bottom: 2px;
    }
  }
 ::v-deep .ivu-table {
    .ivu-table-cell {
      text-align: center !important ;
    }
  }
  .base_page {
    width: 100%;
    height: 34px;
    padding: 5px 0;
  }
  .no_data_wapper {
    min-height: 100px;
    line-height: 100px;
    text-align: center;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    margin: 20px 0;
  }
}
</style>
